import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-763f219f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {}
}
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = { style: {"float":"left"} }
const _hoisted_4 = { class: "form-size" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, "Login User:" + _toDisplayString($setup.store.getters.cognitoUserName), 1 /* TEXT */),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control g-3",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.DEST) = $event))
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.DEST]
          ])
        ]),
        _createElementVNode("div", { style: {"display":"flex","text-align":"center"} }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-width",
            onClick: $setup.linkToOtherWindow
          }, " open tab "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-width",
            onClick: $setup.makeUrl
          }, " ifreame ")
        ]),
        _createElementVNode("div", { style: {"text-align":"left"} }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-width",
            onClick: $setup.openSRDB
          }, " open window ")
        ])
      ]),
      ($setup.isOpen)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            src: $setup.newUrl
          }, null, 8 /* PROPS */, _hoisted_5))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}